import { isMiniProgram, isWx } from './env';
import { logger } from './logger';
export function send(request, _a, url, debug, callback) {
    var _b = (_a === void 0 ? {} : _a).end, end = _b === void 0 ? false : _b;
    var hasCallBack = typeof callback === 'function';
    var data = JSON.stringify({
        alg: '',
        type: 0,
        data: request,
    });
    window.REPORT_LOG && console.log('reportDataSize:', data.length * 3);
    if (debug) {
        if (hasCallBack) {
            callback(null);
        }
    }
    else if (navigator && navigator.sendBeacon && end && !isWx) {
        logger('Sending HTTP request by sendBeacon');
        var res = navigator.sendBeacon(url, data);
        if (hasCallBack) {
            callback(res ? null : new Error('Request fail'));
        }
    }
    else if (XMLHttpRequest) {
        try {
            logger('Sending XML HTTP request by XMLHttpRequest');
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url, end && !!isWx ? false : true);
            xhr.onreadystatechange = function () {
                if (this.readyState === 4 && this.status >= 200 && this.status < 300) {
                    if (hasCallBack) {
                        callback(null);
                    }
                }
                else if (this.readyState === 4) {
                    logger('Failed Server XML HTTP request', this.status);
                    if (hasCallBack) {
                        callback(new Error('Request fail'));
                    }
                }
            };
            xhr.send(data);
        }
        catch (e) {
            logger('Failed XML HTTP request', e);
            if (hasCallBack) {
                callback(new Error('Request fail'));
            }
        }
    }
    else if (isMiniProgram) {
        wx.request({
            url: url,
            data: data,
            success: function () {
                if (hasCallBack) {
                    callback(null);
                }
            },
            fail: function () {
                if (hasCallBack) {
                    callback(new Error('Request fail'));
                }
            },
        });
    }
    else {
        logger.error('该平台没有部署ca支持的请求接口');
    }
}
